//#region IMPORTS
import { setInstoreOrderTypePageNumber } from "../../features/instoreOrderTypes/instoreOrderTypesSlice";
import { useAppDispatch } from "../../store/configureStore";
import { InstoreOrderType } from "../../models/instoreOrderType";
import { MetaData } from "../../models/pagination";
import InstoreOrderTypesTableHeader from "./InstoreOrderTypesTableHeader";
import InstoreOrderTypesTableRow from "./InstoreOrderTypesTableRow";
import MainTable from "../_layout/MainTable";
//#endregion

//#region INTERFACE
interface Props {
  deleteHandler: (item: InstoreOrderType) => void;
  editHandler: (item: InstoreOrderType) => void;
  itemsLoaded: boolean;
  metaData?: MetaData;
  loading?: boolean;
  items: InstoreOrderType[];
  hide?: boolean;
}
//#endregion

export default function InstoreOrderTypesTable({
  deleteHandler,
  editHandler,
  itemsLoaded,
  metaData,
  loading = false,
  items,
  hide = false,
}: Props) {
  //#region SETUP
  // Redux
  const dispatch = useAppDispatch();
  //#endregion

  //#region RENDER
  return (
    <MainTable
      onPageChangeHandler={(page: number) =>
        dispatch(setInstoreOrderTypePageNumber({ page: page }))
      }
      itemsLoaded={itemsLoaded}
      metaData={metaData}
      header={<InstoreOrderTypesTableHeader />}
      hide={hide}
    >
      {items.map((instoreOrderType) => (
        <InstoreOrderTypesTableRow
          deleteHandler={() => deleteHandler(instoreOrderType)}
          editHandler={() => editHandler(instoreOrderType)}
          instoreOrderType={instoreOrderType}
          loading={loading}
          key={instoreOrderType.id}
        />
      ))}
    </MainTable>
  );
  //#endregion
}
